import AppService from "./AppService";

/**
 * ROOT_ADMIN management of the subscription plan catalog (plans, per-duration
 * prices, entitlements/limits).
 */
class SubscriptionPlanService {
  listPlans() {
    return AppService.get("/api/subscription-plans");
  }

  getPlan(id) {
    return AppService.get(`/api/subscription-plans/${id}`);
  }

  createPlan(data) {
    return AppService.post("/api/subscription-plans", data);
  }

  updatePlan(id, data) {
    return AppService.put(`/api/subscription-plans/${id}`, data);
  }

  deactivatePlan(id) {
    return AppService.delete(`/api/subscription-plans/${id}`);
  }

  // Prices
  addPrice(planId, data) {
    return AppService.post(`/api/subscription-plans/${planId}/prices`, data);
  }

  updatePrice(priceId, data) {
    return AppService.put(`/api/subscription-plans/prices/${priceId}`, data);
  }

  deactivatePrice(priceId) {
    return AppService.delete(`/api/subscription-plans/prices/${priceId}`);
  }

  // Entitlements
  setEntitlement(planId, data) {
    return AppService.put(`/api/subscription-plans/${planId}/entitlements`, data);
  }
}

const subscriptionPlanService = new SubscriptionPlanService();
export default subscriptionPlanService;
